<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/Text/acknowledgment">Acknowledgments</a></p>
<p class="toc"><a href="#/Text/introduction">Introduction</a></p>
<p class="toc1"><a href="#/Text/ch1">1. Union Outpost</a></p>
<p class="toc"><span href="#/Text/ch2" title="Link target outside of Sample">2. Sacrifice</span></p>
<p class="toc"><span href="#/Text/ch3" title="Link target outside of Sample">3. Prince John’s Peninsula</span></p>
<p class="toc"><span href="#/Text/ch4" title="Link target outside of Sample">4. A Plan Emerges</span></p>
<p class="toc"><span href="#/Text/ch5" title="Link target outside of Sample">5. Ironclads</span></p>
<p class="toc"><span href="#/Text/ch6" title="Link target outside of Sample">6. The Campaign Commences</span></p>
<p class="toc"><span href="#/Text/ch7" title="Link target outside of Sample">7. A “Dam Failure”</span></p>
<p class="toc"><span href="#/Text/ch8" title="Link target outside of Sample">8. Siege</span></p>
<p class="toc"><span href="#/Text/ch9" title="Link target outside of Sample">9. Consequences</span></p>
<p class="toc1"><span href="#/Text/appI" title="Link target outside of Sample">Appendix I: Order of Battle</span></p>
<p class="toc"><span href="#/Text/appII" title="Link target outside of Sample">Appendix II: Artillery in the Peninsula Campaign</span></p>
<p class="toc"><span href="#/Text/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Text/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Text/author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4cc8c1e5